<template>
  <div class="disclaimer">
    <div class="spin" v-if="registering">
      <spinner size="1x"></spinner>
    </div>

    <div class="content" v-if="disclaimerText">
      <div class="title">{{ $t('registration.channelDisclaimer.title') }}</div>
      <div class="text">
        <p>{{disclaimerText}}</p>
      </div>
      <div class="prompt">{{ $t('registration.channelDisclaimer.prompt') }}</div>
      <div class="buttons">
        <b-button variant="link" :disabled="registering" @click="rejectDisclaimer()">{{ $t('registration.channelDisclaimer.cancel')}}</b-button>
        <b-button variant="primary" :disabled="registering" @click="acceptDisclaimer()">{{ $t('registration.channelDisclaimer.accept') }}</b-button>
      </div>

      <captcha
        v-if="verifyHumanRegistrant"
        @onCaptchaToken="onCaptchaToken"
        ref="captcha"
      ></captcha>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/togo/spinner';
import Captcha from '@/components/captcha';

export default {
  name: 'Disclaimer',

  components: {
    Spinner,
    Captcha
  },

  data() {
    return {
      registering: false
    };
  },

  props: {
    formData:  {
      type: Object,
      required: true
    },
    disclaimerText: {
      type: String,
      required: true
    },
    verifyHumanRegistrant: {
      type: Boolean,
      required: true
    }
  },

  created() {
    this.track('Embedded disclaimer page visited');
  },
  methods: {
    track(eventName, telemetryProps = {}) {
      this.$telemetryTrack(eventName, {
        ...this.$store.state.g2sRecording.embeddedResource,
        ...telemetryProps
      });
    },
    rejectDisclaimer() {
      this.track('Embedded disclaimer reject button clicked', this.formData);
      this.$router.back();
    },

    async acceptDisclaimer() {
      this.registering = true;
      if (!this.verifyHumanRegistrant) {
          this.register();
      } else {
          this.$refs.captcha.execute();
      }
    },

    async onCaptchaToken(token) {
      this.formData.humanRegistrantToken = token;
      this.formData.humanVerificationEngine = 'recaptcha';
      this.register();
    },

    async register() {
      this.track('Embedded disclaimer accept button clicked', this.formData);
      const {registrantKey, recordingKey} = await this.$store.dispatch('g2sRecording/registerAndGetAssets', {
        formData: this.formData
      });

      this.track('Embedded registration complete', this.formData);

      this.$router.push({
        name: 'embedded-recording-view',
        params: {
          recordingKey,
          registrantKey,
          controlsPlayback: true
        }
      });
    }
  }
}
</script>

<style scoped lang="sass">
  @import 'src/scss/variables'

  .disclaimer
    display: flex
    align-items: center
    justify-content: center
    color: $white
    height: 100%
    padding: 30px 24px
    background-image: linear-gradient(243deg, #7b54f7, #159dea 89%, #1397e9)

    .spin
      display: flex
      align-items: center
      justify-content: center
      font-size: 6em
      position: absolute
      left: 0
      right: 0

    .content
      min-height: 50%
      max-height: 100%
      width: 100%
      display: flex
      flex-direction: column

      .title
        font-weight: bold
        margin-bottom: 16px
        text-align: center
        font-size: 18px
        line-height: 24px

      .text
        flex: 1 1 100%
        text-align: left
        overflow-y: auto
        white-space: pre-line
        font-size: 14px
        min-height: 60px

      .prompt
        font-weight: bold
        margin: 15px 0 15px 0
        flex-shrink: 0
        font-size: 16px

      .buttons
        display: flex
        justify-content: flex-end
        flex-shrink: 0

        button
          color: white
          margin-left: 8px
</style>
